import BlockText from '../block/BlockText'
import BlockView from '../block/BlockView'
import BlockImage from '../block/BlockImage'
import BlockSlide from '../block/BlockSlide'
import BlockSlideshow from '../block/BlockSlideshow'
import {BlockTeaser, BlockIcon, BlockAction, BlockVideo, BlockRegion} from '../block/Blocks'
import {blockTypes as customBlockTypes, blockRenderers} from '../../conf/block'

const blockTypes = Object.assign({}, {
	block: {
		name: 'Container',
		container: true,
		fields: [
		{
			name: 'o',
			type: 'bool',
			label: 'Orizontal',
			render: null,
			prepare: config => {
				if (config.block.o) {
					config.classes.push('horizontal')
					if (config.childs) config.classes.push('cols-'+ config.childs.length)
				}
				return config
			}
		},
		{
			name: 'border',
			type: 'class',
			label: 'Border',
		},
		{
			name: 'bgColor',
			type: 'text',
			label: 'Culoare fond',
			render: null,
			prepare: config => {if (config.block.bgColor) config.style.backgroundColor = config.block.bgColor; return config}
		},
		{
			name: 'bg',
			type: 'img',
			label: 'Fundal',
			single: true,
			render: null
		},
		{
			name: 'bgProp',
			type: 'bool',
			label: 'Dimensiuni proportionale cu fundalul',
			render: null,
			prepare: config => {if (config.block.bgProp) config.classes.push('bg-prop'); return config}
		},
	]},
	
	text: {
		name: 'Card (Text, imagine)',
		renderer: BlockText,
		//contentRender: props => 
		fields: [
		{
			name: 'align',
			type: 'radio',
			values: [
				{
					val: 'top',
					label: 'Imagine sus'
				},
				{
					val: 'left',
					label: 'Imagine stânga'
				},
				{
					val: 'right',
					label: 'Imagine dreapta'
				},
			],
			label: 'Aliniere',
			prepare: config => {
				if (((config.block.img && config.block.img.length>0) || config.block.video || (config.block.vid && config.block.vid.length>0)) 
					&& config.block.align) config.classes.push('img-'+config.block.align)
				return config
			}
		},
		{
			name: 'contain',
			type: 'class',
			label: 'Imagine încadrată',
			//prepare: (e, props) => {if (e.contain) props.classes.push('contain'); return props}
		},
		{
			name: 'big',
			type: 'class',
			label: 'Text mare'
		},
		{
			name: 'icon',
			type: 'text',
			label: 'Iconiță'
		},
		{
			name: 'text',
			type: 'html',
			label: 'Text',
			t: true
		},
		{
			name: 'video',
			type: 'video',
			label: 'Video'
		},
		{
			name: 'vid',
			type: 'vid',
			label: 'Video'
		},
		{
			name: 'img',
			type: 'img',
			label: 'Imagine',
			single: false,
		},
		{
			name: 'call',
			type: 'text',
			label: 'Chemare',
			t: true
		},
		{
			name: 'link',
			type: 'text',
			label: 'Legătură',
			t:true
		},
		{
			name: 'bgColor',
			type: 'text',
			label: 'Culoare fond'
		},
		{
			name: 'bg',
			type: 'img',
			label: 'Fundal',
			single: true,
			render: null
		},
		{
			name: 'bgProp',
			type: 'class',
			label: 'Dimensiuni proportionale cu fundalul',
			single: true
		}
	]},
	
	icon: {
		name: 'Icon',
		renderer: BlockIcon,
		fields: [
		{
			name: 'img',
			type: 'img',
			label: 'Icon',
			single: true,
		},
		{
			name: 'big',
			type: 'bool',
			label: 'Text mare'
		},
		{
			name: 'text',
			type: 'html',
			label: 'Text',
			t:true
		}
	]},
	
	image: {
		name: 'Imagini',
		renderer: BlockImage,
		fields: [
		{
			name: 'text',
			type: 'html',
			label: 'Text',
			t:true
		},
		{
			name: 'img',
			type: 'img',
			label: 'Imagine',
			single: false,
		},
		{
			name: 'multiple',
			type: 'bool',
			label: 'Multiple'
		},
		{
			name: 'carousel',
			type: 'bool',
			label: 'Carusel'
		},
	]},
	
	video: {
		name: 'Video',
		renderer: BlockVideo,
		fields: [
		{
			name: 'video',
			type: 'video',
			label: 'Link Video'
		},
		{
			name: 'vid',
			type: 'vid',
			label: 'Video'
		},
	]},
	
	hero: {
		name: 'Hero',
		fields: [
		{
			name: 'size',
			type: 'radio',
			values: [
				{
					val: 'full',
					label: 'Intreg ecranul'
				},
				{
					val: 'bg-prop',
					label: 'Proportional'
				},
				{
					val: 'slim',
					label: 'Slim'
				},
			],
			label: 'Mărime',
			prepare: (config) => {
				if(config.block.size) config.classes.push(config.block.size)
				else config.classes.push('slim')
				//if(e.size==='bg-prop') props.block.bgProp = true
				return config
			}
		},
		{
			name: 'img',
			type: 'img',
			label: 'Imagine',
			single: false,
			render: null,
			prepare: (config) => {
				//props.bg = null
				if(config.block.img && config.block.img.length>0) config.bg = config.block.img
				
		
				//if(props.entity && props.entity.header && props.entity.header.length>0) props.bg = props.entity.header
				//if(props.node && props.node.header && props.node.header.length>0) props.bg = props.node.header
				return config
			}
		},
		{
			name: 'h1',
			type: 'html',
			label: 'Supratitlu',
			t:true,
			tag: 'h2'
		},
		{
			name: 'h2',
			type: 'html',
			label: 'Titlu',
			t:true,
			tag: 'h1'
		},
		{
			name: 'h3',
			type: 'html',
			label: 'Subtitlu',
			t:true,
			tag: 'h3'
		},
		{
			name: 'text',
			type: 'html',
			label: 'Text',
			t:true
		},
		],
		groups: [{
			name: 'hero',
			fields: ['h1', 'h2', 'h3', 'text']
		}]
	},
	slideshow: {
		name: 'Slideshow',
		renderer: BlockSlideshow,
		container: true,
		fields: []
	},
	slide: {
		name: 'Slide',
		renderer: BlockSlide,
		fields: [
		{
			name: 'slim',
			type: 'bool',
			label: 'Slim'
		},
		{
			name: 'img',
			type: 'img',
			label: 'Imagine',
			single: false,
		},
		{
			name: 'h3',
			type: 'html',
			label: 'Supratitlu',
			t:true
		},
		{
			name: 'h1',
			type: 'html',
			label: 'Titlu',
			t:true
		},
		{
			name: 'h2',
			type: 'html',
			label: 'Subtitlu',
			t:true
		},
		{
			name: 'text',
			type: 'html',
			label: 'Text',
			t:true
		},
		{
			name: 'call',
			type: 'text',
			label: 'Chemare',
			t:true
		},
		{
			name: 'link',
			type: 'text',
			label: 'Legătură',
			t:true
		}
	]},
	
	action: {
		name: 'Action',
		renderer: BlockAction,
		fields: [
		{
			name: 'icon',
			type: 'text',
			label: 'Iconiță'
		},
		{
			name: 'call',
			type: 'text',
			label: 'Chemare',
			t:true
		},
		{
			name: 'link',
			type: 'text',
			label: 'Legătură',
			t:true
		}
	]},
	
	teaser: {
		name: 'Teaser',
		renderer: BlockTeaser,
		fields: [
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
			t:true
		},
		{
			name: 'summary',
			type: 'html',
			label: 'Sumar',
			t:true
		},
		{
			name: 'thumb',
			type: 'img',
			label: 'Miniatură',
			single: true,
		},
		{
			name: 'link',
			type: 'text',
			label: 'Legătură',
			t:true
		},
		{
			name: 'bgColor',
			type: 'text',
			label: 'Culoare fond'
		},
		{
			name: 'bg',
			type: 'img',
			label: 'Fundal',
			single: true
		},
		{
			name: 'bgProp',
			type: 'bool',
			label: 'Dimensiuni proportionale cu fundalul',
			single: true
		}
	]},
	
	view: {
		name: 'Vizualizare',
		renderer: BlockView,
		fields: [
		{
			name: 'icon',
			type: 'img',
			label: 'Miniatură',
			single: true,
		},
		{
			name: 'title',
			type: 'text',
			label: 'Titlu',
			t:true
		},
		{
			name: 'view',
			type: 'text',
			label: 'Vizualizare'
		},
		{
			name: 'collection',
			type: 'text',
			label: 'Colecție'
		},
		{
			name: 'query',
			type: 'text',
			label: 'Query',
			multi: true,
			t:true
		},
		{
			name: 'projection',
			type: 'text',
			label: 'Projection',
			multi: true
		},
		{
			name: 'paginate',
			type: 'bool',
			label: 'Paginare'
		},
		{
			name: 'pageSize',
			type: 'text',
			label: 'Page size'
		},
		{
			name: 'sort',
			type: 'text',
			label: 'Sortare',
			multi: true
		},
		{
			name: 'rowRenderer',
			type: 'text',
			label: 'Row renderer'
		},
		{
			name: 'viewRenderer',
			type: 'text',
			label: 'View renderer'
		},
		{
			name: 'moreText',
			type: 'text',
			label: 'More text',
			t:true
		},
		{
			name: 'moreLink',
			type: 'text',
			label: 'More link'
		},
		{
			name: 'bgColor',
			type: 'text',
			label: 'Culoare fond'
		},
		{
			name: 'bg',
			type: 'img',
			label: 'Fundal',
			single: true
		},
		{
			name: 'bgProp',
			type: 'bool',
			label: 'Dimensiuni proportionale cu fundalul',
			single: true
		},
	]},
	
	region: {
		name: 'Regiune',
		renderer: BlockRegion,
		container: true,
		fields: [
			{name: 'region', type: 'select', dataSource: 'regionList', label: 'Regiune'}
		]
	}
}, customBlockTypes)

export {blockTypes, blockRenderers}



// WEBPACK FOOTER //
// ./src/fm/conf/block.js